module.exports = __webpack_public_path__ + "static/media/cms.efc53ae8.svg";